module.exports = __webpack_public_path__ + "img/product_86.896bc67.svg";